import { render, staticRenderFns } from "./type11.vue?vue&type=template&id=81589142&scoped=true&"
import script from "./type11.vue?vue&type=script&lang=js&"
export * from "./type11.vue?vue&type=script&lang=js&"
import style0 from "./type11.vue?vue&type=style&index=0&id=81589142&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81589142",
  null
  
)

export default component.exports